import * as Sentry from "@sentry/nextjs";

const hasValue = (value) => value !== undefined && value !== null && value !== "";

export const setSentryExamContext = ({ userInfo = {}, router, time } = {}) => {
  if (hasValue(userInfo.Tester_IDX) || hasValue(userInfo.Tester_Name)) {
    Sentry.setUser({
      id: hasValue(userInfo.Tester_IDX) ? String(userInfo.Tester_IDX) : undefined,
      username: userInfo.Tester_Name,
    });
  }

  const tags = {
    page: router?.pathname,
    mode: router?.query?.mode,
    type: router?.query?.type,
    roomId: userInfo.ROOM_IDX,
    testerIdx: userInfo.Tester_IDX,
    isPreCheck: userInfo.isPreCheck,
  };

  Object.entries(tags).forEach(([key, value]) => {
    if (hasValue(value)) {
      Sentry.setTag(key, String(value));
    }
  });

  Sentry.setContext("exam", {
    testerIdx: userInfo.Tester_IDX,
    testerName: userInfo.Tester_Name,
    roomIdx: userInfo.ROOM_IDX,
    page: router?.pathname,
    mode: router?.query?.mode,
    type: router?.query?.type,
    afterTime: time?.afterTime,
    timeLimit: time?.timeLimit,
  });
};

export const addSentryBreadcrumb = ({ category, message, data, level = "info" }) => {
  Sentry.addBreadcrumb({
    category,
    message,
    level,
    data,
  });
};
